// packages/components/src/doctor-ai/SpecialistAttribution.tsx
import React from 'react';
import { BrainCircuit, HeartPulse, Stethoscope, TestTube, Radio } from 'lucide-react';

interface SpecialistAttributionProps {
  source?: string;
  className?: string;
}

const specialistMap: Record<string, { icon: React.ElementType; name: string }> = {
  'Cardiologist AI': { icon: HeartPulse, name: 'Cardiologist AI' },
  'Neurologist AI': { icon: BrainCircuit, name: 'Neurologist AI' },
  'Radiologist AI': { icon: Radio, name: 'Radiologist AI' },
  'Lab Analyst AI': { icon: TestTube, name: 'Lab Analyst AI' },
  'General Practitioner AI': { icon: Stethoscope, name: 'GP AI' },
};

export const SpecialistAttribution: React.FC<SpecialistAttributionProps> = ({ source, className }) => {
  if (!source) return null;

  const specialist = specialistMap[source] || { icon: Stethoscope, name: source };
  const Icon = specialist.icon;

  return (
    <div className={`flex items-center gap-2 text-xs text-slate-500 mb-2 px-1 ${className}`}>
      <Icon size={14} />
      <span>Analysis by: <strong>{specialist.name}</strong></span>
    </div>
  );
};